export const TOKEN_STORAGE_KEYS = {
  LOGIN_TOKEN: 'login.token',
  LOGIN_EXPIRES: 'login.expires',
  GRAPH_TOKEN: 'graph.token',
  GRAPH_EXPIRES: 'graph.expires',
}

export const MSAL_EVENTS = {
  LOGIN_SUCCESS: 'msal:loginSuccess',
  ACQUIRE_TOKEN_SUCCESS: 'msal:acquireTokenSuccess',
}

export const MSAL_ERRORS = {
  NOT_INITIALIZED: 'MSAL is not initialized yet. Please try again.',
  NO_ACTIVE_ACCOUNT: 'No active account found',
  NO_ACTIVE_ACCOUNT_RESTORE: 'No active account found after restoration attempt',
  USER_INTERACTION_REQUIRED: 'Silent token acquisition failed, user interaction required',
}

export const GRAPH_SCOPES = {
  USER_READ: ['User.Read'],
}

export const TOKEN_REFRESH_BUFFER_MS = 5 * 60 * 1000 // 5 minutes in milliseconds
